export default __webpack_public_path__ + "static/InputCover-44a655293458ca4392c316571c4a6f54.png";